import React from "react";
import { BaseModal } from "./BaseModal";
import { useStore } from "../../stores/store";
import { ModalKeys } from "../../interfaces/config";

export default function MaxRecordExceededModal() {
  const { isActive, deactivateTool } = useStore();
  return (
    <BaseModal
      active={isActive(ModalKeys.ZONING_NOTIFICATION)}
      title="ZONING NOTIFICATION"
    >
      <div className="p-3 font-helvetica text-sm">
        <p>Attention:</p>
        <p>
          You have selected a parcel which is identified as containing more than
          one zoning district. If, after looking at the map, you believe this to
          be an error, please{" "}
          <a
            className="link"
            href="mailto:plandev@mchenrycountyil.gov?subject=Verify Zoning"
          >
            contact us
          </a>{" "}
          and we will verify the zoning of the parcel in writing. PlanDev Viewer
          is not an official zoning map.
        </p>
      </div>
      <div className="bg-[#f5f5f5] border-t border-[#ddd] w-full text-right p-1">
        <button
          onClick={() => deactivateTool(ModalKeys.ZONING_NOTIFICATION)}
          className="btn-athena btn-sm mr-1"
        >
          Ok
        </button>
      </div>
    </BaseModal>
  );
}
